if (!customElements.get('corporate-invoice')) {
  customElements.define(
    'corporate-invoice',
    class CorporateInvoice extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.fields = document.getElementById(this.checkbox.getAttribute('aria-controls'));
        this.taxOfficeInput = this.fields.querySelector('input[type="text"][name="attributes[Vergi Dairesi]"]');
        this.vknInput = this.fields.querySelector('input[type="text"][name="attributes[VKN]"]');

        this.checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
        this.taxOfficeInput.addEventListener('input', this.onTaxOfficeInput.bind(this));
        this.vknInput.addEventListener('input', this.onVknInput.bind(this));
        this.fields.addEventListener('change', this.save.bind(this));

        this.toggleAcceleratedCheckout();
      }

      get textInputs() {
        return [this.taxOfficeInput, this.vknInput];
      }

      get taxOfficeError() {
        return this.taxOfficeInput.value.trim() === '' ? this.dataset.errorTaxOfficeRequired : '';
      }

      // VKN is 10 digits, TCKN (şahıs şirketi) is 11 digits.
      get vknError() {
        if (this.vknInput.value === '') return this.dataset.errorVknRequired;
        if (!/^\d{10,11}$/.test(this.vknInput.value)) return this.dataset.errorVknInvalid;
        return '';
      }

      get isValid() {
        return !this.checkbox.checked || (this.taxOfficeError === '' && this.vknError === '');
      }

      onCheckboxChange() {
        const checked = this.checkbox.checked;

        this.fields.hidden = !checked;
        this.textInputs.forEach((input) => {
          input.disabled = !checked;
          this.setError(input, '');
        });
        this.toggleAcceleratedCheckout();
        this.save();

        if (checked) this.taxOfficeInput.focus();
      }

      onTaxOfficeInput() {
        if (this.taxOfficeError === '') this.setError(this.taxOfficeInput, '');
        this.toggleAcceleratedCheckout();
      }

      onVknInput() {
        // Digits only, max 11.
        const digits = this.vknInput.value.replace(/\D/g, '').slice(0, 11);
        if (digits !== this.vknInput.value) this.vknInput.value = digits;

        if (this.vknError === '') this.setError(this.vknInput, '');
        this.toggleAcceleratedCheckout();
      }

      save() {
        const checked = this.checkbox.checked;
        const body = JSON.stringify({
          attributes: {
            'Kurumsal Fatura': checked ? this.checkbox.value : '',
            'Vergi Dairesi': checked ? this.taxOfficeInput.value.trim() : '',
            'VKN': checked ? this.vknInput.value : ''
          }
        });
        fetch(`${theme.routes.cart_update_url}`, { ...theme.utils.fetchConfig(), ...{ body } });
      }

      validate() {
        if (!this.checkbox.checked) return true;

        this.setError(this.taxOfficeInput, this.taxOfficeError);
        this.setError(this.vknInput, this.vknError);

        const firstInvalid = this.textInputs.find((input) => input.hasAttribute('aria-invalid'));
        firstInvalid?.focus();
        return !firstInvalid;
      }

      setError(input, message) {
        const error = document.getElementById(input.getAttribute('aria-describedby'));
        error.lastElementChild.textContent = message;
        error.hidden = message === '';
        message === '' ? input.removeAttribute('aria-invalid') : input.setAttribute('aria-invalid', 'true');
      }

      // Express checkout buttons (Shop Pay etc.) skip the form submit, so hide them while the fields are invalid.
      toggleAcceleratedCheckout() {
        const buttons = this.closest('main-cart, cart-drawer')?.querySelector('.additional-checkout-buttons');
        if (buttons) buttons.hidden = !this.isValid;
      }
    }
  );

  // Block checkout while the corporate invoice fields are invalid.
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name !== 'checkout') return;

    const invoice = event.target.closest('main-cart, cart-drawer')?.querySelector('corporate-invoice');
    if (invoice && !invoice.validate()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}
